import { useState } from 'react';
import { signIn, STAFF_DOMAIN } from '../lib/firebase';
import BrandLogo from '../components/BrandLogo';

export default function Login() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onClick() {
    setBusy(true);
    setError(null);
    try {
      await signIn();
    } catch (e) {
      setError(e instanceof Error ? e.message : '로그인에 실패했습니다.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-full place-items-center p-6">
      <div className="card w-full max-w-sm p-8 text-center">
        <BrandLogo variant="hero" />

        <button className="btn-primary mt-8 w-full" onClick={onClick} disabled={busy}>
          {busy ? '로그인 중…' : 'Google 계정으로 로그인'}
        </button>

        <p className="mt-4 text-xs text-ink-faint">사내 계정({STAFF_DOMAIN})만 사용할 수 있습니다.</p>
        {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      </div>
    </div>
  );
}
